import { push } from 'connected-react-router';
import { userFormSelector, userUidSelector, userModelLocaleSelector } from 'store/selectors/base.selectors';
import { pick } from 'constants/lodash';
import { updateCurrentUser, getUserData, doSignup, doLogin, doLogout } from 'store/api/user';
import { getSyncedSectors } from 'store/api/entity';
import Locale from 'constants/locale';
import { ErrorToast } from 'utils/toasts';

const ACTION_PREFIX = '@@user';
export const OPENED_LOGIN_MODAL = `${ACTION_PREFIX}/OPENED_LOGIN_MODAL`;
export const CLOSED_LOGIN_MODAL = `${ACTION_PREFIX}/CLOSED_LOGIN_MODAL`;
export const OPENED_EDIT_MODAL = `${ACTION_PREFIX}/OPENED_EDIT_MODAL`;
export const CLOSED_EDIT_MODAL = `${ACTION_PREFIX}/CLOSED_EDIT_MODAL`;
export const UPDATED_USER_FORM = `${ACTION_PREFIX}/UPDATED_USER_FORM`;
export const UPDATED_USER = `${ACTION_PREFIX}/UPDATED_USER`;
export const LOGGED_IN = `${ACTION_PREFIX}/LOGGED_IN`;
export const LOGGED_OUT = `${ACTION_PREFIX}/LOGGED_OUT`;
export const AUTH_FAILURE = `${ACTION_PREFIX}/AUTH_FAILURE`;

export const openEditModal = () => ({ type: OPENED_EDIT_MODAL });
export const closeEditModal = () => ({ type: CLOSED_EDIT_MODAL });
export const openLoginModal = () => ({ type: OPENED_LOGIN_MODAL });
export const closeLoginModal = () => ({ type: CLOSED_LOGIN_MODAL });
export const updateUserForm = (key, value) => ({ type: UPDATED_USER_FORM, key, value });

const onLogin = dispatch => result => {
  const user = result.user || result;
  return Promise.all([getSyncedSectors(), getUserData(user.uid)]).then(([sectors, userData]) => {
    dispatch(push('/'));
    dispatch({ type: LOGGED_IN, user: { ...user, ...userData }, sectors });
    return result;
  });
};

export const signup = intl => (dispatch, getState) => {
  const { username, password, confirm, displayName } = userFormSelector(getState());
  if (!username || !displayName || !password || !confirm) return dispatch({ type: AUTH_FAILURE, error: 'Username, display name, and password are required.' });
  if (password !== confirm) return dispatch({ type: AUTH_FAILURE, error: intl.formatMessage({ id: 'misc.noPasswordMatch' }) });
  return doSignup(username, password, displayName).then(onLogin(dispatch)).catch(error => {
    dispatch({ type: AUTH_FAILURE, error: error.message });
    throw error;
  });
};

export const login = intl => (dispatch, getState) => {
  const { username, password } = userFormSelector(getState());
  if (!username || !password) return dispatch({ type: AUTH_FAILURE, error: 'Username and password are required.' });
  return doLogin(username, password).then(onLogin(dispatch)).catch(error => {
    dispatch({ type: AUTH_FAILURE, error: error.message });
    throw error;
  });
};

export const updateUser = intl => (dispatch, getState) => {
  const state = getState();
  const uid = userUidSelector(state);
  let filteredForm = pick(userFormSelector(state), 'displayName', 'locale');
  if (!Locale[filteredForm.locale || 'en']) filteredForm = { ...filteredForm, locale: 'en' };
  return updateCurrentUser(uid, filteredForm).then(() => {
    if (userModelLocaleSelector(state) !== (filteredForm.locale || 'en')) window.location.reload();
    else dispatch({ type: UPDATED_USER, user: filteredForm });
  }).catch(err => {
    dispatch(ErrorToast({ title: intl.formatMessage({ id: 'misc.error' }), message: intl.formatMessage({ id: 'misc.reportProblemPersists' }) }));
    console.error(err);
  });
};

export const logout = intl => dispatch => doLogout().then(() => {
  dispatch(push('/'));
  dispatch({ type: LOGGED_OUT });
}).catch(err => {
  dispatch(ErrorToast({ title: intl.formatMessage({ id: 'misc.error' }), message: intl.formatMessage({ id: 'misc.reportProblemPersists' }) }));
  console.error(err);
});
